module.exports = __webpack_public_path__ + "img/asian-barbequed-pork-loin.6fd7aea6.jpg";